import React, { useState } from "react";
import FeatherIcon from "feather-icons-react";
import { useAppState } from "../../context/appContex";
import { filterItems } from "../../utils";
import { ReactComponent as ReloadIcon } from "../icons/reload.svg";
import { ReactComponent as LogoutIcon } from "../icons/log-out.svg";
import { ReactComponent as ClockIcon } from "../icons/clock.svg";

const INFO_ID = "HELP";
const USER_ID = "USER";

const ActionDropDown: React.FC = () => {
  const [selectedId, setSelectedId] = useState("");

  const { user, renderFlag, languages, menuData, init } = useAppState();

  const toggleMenu = (id: string) => {
    if (id) {
      if (selectedId && id === selectedId) {
        setSelectedId("");
      } else {
        setSelectedId(id);
      }
    }
  };

  const { infoGroup, settingsGroup, authGroup } = filterItems(
    menuData?.system?.items || [],
    ["sys-menu-terms", "sys-menu-help"]
  );

  const renderInfoGroup = () => {
    return (
      <div className='menu-item'>
        <ul className='inner-group'>
          {infoGroup.map((info) => {
            return (
              <li className='nav-item inner-nav top' key={info.title}>
                <div
                  className='nav-text-inner'
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {info.iconClass ? (
                    <FeatherIcon
                      icon={info.iconClass}
                      height='24px'
                      width='24px'
                    />
                  ) : (
                    <FeatherIcon icon='info' height='24px' width='24px' />
                  )}
                  {info.targetType === "BLANK" ||
                  info.targetType === "POPUP" ? (
                    <a
                      href={info.targetUrl}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='action-drop-text'
                    >
                      {info.title}
                    </a>
                  ) : (
                    <a href={info.targetUrl} className='action-drop-text'>
                      {info.title}
                    </a>
                  )}
                </div>
              </li>
            );
          })}

          <li className='nav-item inner-nav'>
            <div
              className='nav-text-inner info-group'
              style={{ display: "flex", alignItems: "center" }}
              onClick={() => init("REFRESH")}
            >
              <ReloadIcon />
              <span className='action-drop-text'>Reload Menu</span>
            </div>
          </li>
        </ul>
      </div>
    );
  };

  const renderSettings = () => {
    return (
      <div className='menu-item'>
        <ul className='inner-group'>
          {settingsGroup.map((sett) => {
            return (
              <li className='nav-item inner-nav top' key={sett.title}>
                <div
                  className='nav-text-inner'
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {sett.iconClass ? (
                    <FeatherIcon
                      icon={sett.iconClass}
                      height='24px'
                      width='24px'
                    />
                  ) : null}
                  {sett.targetType === "BLANK" ||
                  sett.targetType === "POPUP" ? (
                    <a
                      href={sett.targetUrl}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='action-drop-text'
                    >
                      {sett.title}
                    </a>
                  ) : (
                    <a href={sett.targetUrl} className='action-drop-text'>
                      {sett.title}
                    </a>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  return (
    <ul className='submenu-wrapper'>
      <li
        className={selectedId === INFO_ID ? "nav-item active-menu" : "nav-item"}
      >
        <span
          onClick={() => toggleMenu(INFO_ID)}
          className='nav-text'
          style={selectedId === INFO_ID ? { fontWeight: "bold" } : {}}
        >
          Help and contact info
        </span>
        <>
          {selectedId && selectedId === INFO_ID ? (
            <FeatherIcon
              icon='chevron-down'
              className='drop-down'
              onClick={() => toggleMenu(INFO_ID)}
            />
          ) : (
            <FeatherIcon
              icon='chevron-right'
              className='drop-down'
              onClick={() => toggleMenu(INFO_ID)}
            />
          )}
        </>
        {selectedId === INFO_ID && renderInfoGroup()}
      </li>
      <li
        className={selectedId === USER_ID ? "nav-item active-menu" : "nav-item"}
      >
        <span
          className='nav-text'
          onClick={() => toggleMenu(USER_ID)}
          style={selectedId === USER_ID ? { fontWeight: "bold" } : {}}
        >
          {user}
        </span>
        <>
          {selectedId && selectedId === USER_ID ? (
            <FeatherIcon
              icon='chevron-down'
              className='drop-down'
              onClick={() => toggleMenu(USER_ID)}
            />
          ) : (
            <FeatherIcon
              icon='chevron-right'
              className='drop-down'
              onClick={() => toggleMenu(USER_ID)}
            />
          )}
        </>
        {selectedId === USER_ID && renderSettings()}
      </li>
      <div className='flex-col'>
        {languages.map((lang) => {
          return (
            <div className='language-item' key={lang.isoCode}>
              <div className='right'>
                {renderFlag(lang.isoCode)}
                <a href={lang.targetUrl} className='action-drop-text'>
                  {lang.nativeName}
                </a>
              </div>
              {lang.isActive && <FeatherIcon icon='check' size={20} />}
            </div>
          );
        })}
      </div>

      {authGroup.map((auth) => {
        if (auth.id === "sys-menu-logout") {
          return (
            <div
              key={auth.targetUrl}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                paddingRight: "20px",
                paddingLeft: "20px",
                marginTop: "10px",
              }}
            >
              <button className='btn btn-main'>
                {" "}
                <LogoutIcon />
                {auth.targetType === "BLANK" || auth.targetType === "POPUP" ? (
                  <a
                    href={auth.targetUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {auth.title}
                  </a>
                ) : (
                  <a href={auth.targetUrl}>{auth.title}</a>
                )}
              </button>
            </div>
          );
        }

        return (
          <div
            key={auth.targetUrl}
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              paddingRight: "20px",
              paddingLeft: "20px",
            }}
          >
            <button className='btn clock-out'>
              <ClockIcon />
              {auth.targetType === "BLANK" || auth.targetType === "POPUP" ? (
                <a
                  href={auth.targetUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {auth.title}
                </a>
              ) : (
                <a href={auth.targetUrl}>{auth.title}</a>
              )}
            </button>
          </div>
        );
      })}
    </ul>
  );
};

export default ActionDropDown;
